import { cancelInternalTransfer } from 'commons/service/bank/internalTransfer'
import { InternalTransferDeprecated } from 'commons/types/DTO/bank'
import { WriteHook, useMutationManager } from 'state-manager'

export const useCancelInternalTransfer: WriteHook<number | undefined, InternalTransferDeprecated> = (opts) =>
  useMutationManager(cancelInternalTransfer, opts)
